import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Não foi possível carregar os dados", -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Doughnut = _resolveComponent("Doughnut")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loaded)
      ? (_openBlock(), _createBlock(_component_Doughnut, {
          key: 0,
          styles: _ctx.stylesBar,
          "chart-options": _ctx.chartOptions,
          "chart-data": _ctx.chartData
        }, null, 8, ["styles", "chart-options", "chart-data"]))
      : _createCommentVNode("", true),
    (_ctx.loaded && _ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true)
  ]))
}